import styled, { css } from 'styled-components';
import Paragraph from '../Paragraph';
import Caption from '../Caption';
import Icon from '../Icon';
import Link from '../Link';
import { rem } from 'polished';
import { prefix } from '../../tools/settings';

function gridTemplateColumns(columns) {
  if (columns === 'auto') {
    return "\n        grid-template-columns: repeat(auto-fill, minmax(246px, 1fr));\n        grid-auto-rows: 1fr;";
  } else {
    return "grid-template-columns: repeat(".concat(columns, ", 1fr);");
  }
}

var Groups = styled.div.withConfig({
  displayName: "Groupsstyles__Groups",
  componentId: "sc-1lswi0o-0"
})([""]);
var GroupsHeader = styled.div.withConfig({
  displayName: "Groupsstyles__GroupsHeader",
  componentId: "sc-1lswi0o-1"
})(["margin-bottom:12px;&:empty{display:none;}"]);
var GroupsLink = styled(Link).withConfig({
  displayName: "Groupsstyles__GroupsLink",
  componentId: "sc-1lswi0o-2"
})([""]);
var GroupsDescription = styled(Paragraph).attrs({
  isSemibold: true
}).withConfig({
  displayName: "Groupsstyles__GroupsDescription",
  componentId: "sc-1lswi0o-3"
})(["max-width:70%;"]);
var GroupInfoIcon = styled(Icon).attrs({
  icon: 'info-sign',
  color: 'var(--dentsu-color-n650)',
  size: 14
}).withConfig({
  displayName: "Groupsstyles__GroupInfoIcon",
  componentId: "sc-1lswi0o-4"
})([""]);
var Group = styled.div.withConfig({
  displayName: "Groupsstyles__Group",
  componentId: "sc-1lswi0o-5"
})(["", " > .", "-subheading{font-size:var(--dentsu-font-size-16) !important;}"], function (props) {
  return props.isNested ? css([".", "-groups__label{font-size:var(--dentsu-font-size-16);}"], prefix) : css(["display:grid;", " grid-row-gap:8px;grid-column-gap:8px;"], function (props) {
    return gridTemplateColumns(props.columns);
  });
}, prefix);
var GroupItem = styled.div.withConfig({
  displayName: "Groupsstyles__GroupItem",
  componentId: "sc-1lswi0o-6"
})(["background:var(--dentsu-color-white);border:1px solid var(--dentsu-color-n200);height:48px;padding:8px 8px 8px 16px;display:flex;justify-content:space-between;border-radius:8px;align-items:center;"]);
var GroupMetadata = styled(Caption).withConfig({
  displayName: "Groupsstyles__GroupMetadata",
  componentId: "sc-1lswi0o-7"
})(["color:var(--dentsu-color-n700);margin-bottom:2px;"]);
var GroupEmpty = styled.div.withConfig({
  displayName: "Groupsstyles__GroupEmpty",
  componentId: "sc-1lswi0o-8"
})(["background:var(--dentsu-color-n50);border-radius:var(--dentsu-radius-8);padding:24px;text-align:center;color:var(--dentsu-color-n700);font-size:var(--dentsu-font-size-14);"]);
var GroupLabel = styled.h3.attrs({
  className: "".concat(prefix, "-groups__label")
}).withConfig({
  displayName: "Groupsstyles__GroupLabel",
  componentId: "sc-1lswi0o-9"
})(["font-size:var(--dentsu-font-size-20);margin-bottom:", ";font-weight:var(--dentsu-font-weight-semibold);button{position:relative;margin-left:2px;margin-top:0;}"], rem(16));
var GroupText = styled.span.withConfig({
  displayName: "Groupsstyles__GroupText",
  componentId: "sc-1lswi0o-10"
})(["font-size:var(--dentsu-font-size-12);line-height:", ";hyphens:auto;word-break:break-word;"], rem(16));
var GroupControls = styled.div.withConfig({
  displayName: "Groupsstyles__GroupControls",
  componentId: "sc-1lswi0o-11"
})(["display:flex;"]);
var GroupSection = styled.section.attrs({
  className: "".concat(prefix, "-groups__section")
}).withConfig({
  displayName: "Groupsstyles__GroupSection",
  componentId: "sc-1lswi0o-12"
})(["border:1px dotted var(--dentsu-color-n550);padding:24px;position:relative;background:var(--dentsu-color-n25);+ .", "-groups__section{margin-top:16px;}"], prefix);
var GroupActions = styled.div.withConfig({
  displayName: "Groupsstyles__GroupActions",
  componentId: "sc-1lswi0o-13"
})(["position:absolute;top:20px;right:20px;"]);
var GroupsHeaderActions = styled.div.withConfig({
  displayName: "Groupsstyles__GroupsHeaderActions",
  componentId: "sc-1lswi0o-14"
})(["padding-top:8px;display:flex;justify-content:flex-end;"]);
export var Styled = {
  Groups: Groups,
  GroupsHeader: GroupsHeader,
  GroupsHeaderActions: GroupsHeaderActions,
  GroupsDescription: GroupsDescription,
  GroupsLink: GroupsLink,
  Group: Group,
  GroupLabel: GroupLabel,
  GroupSection: GroupSection,
  GroupItem: GroupItem,
  GroupMetadata: GroupMetadata,
  GroupText: GroupText,
  GroupActions: GroupActions,
  GroupControls: GroupControls,
  GroupInfoIcon: GroupInfoIcon,
  GroupEmpty: GroupEmpty
};